var map = {
	"./22/rank-1.png": 66768,
	"./22/rank-2.png": 39882,
	"./22/rank-3.png": 23178,
	"./car/rank-1.png": 95446,
	"./car/rank-2.png": 83646,
	"./car/rank-3.png": 39252,
	"./human/rank-1.png": 9090,
	"./human/rank-2.png": 15877,
	"./human/rank-3.png": 69474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49478;